import React, { useState, useCallback } from 'react';
import { FaArrowRotateRight } from 'react-icons/fa6';
import toast from 'react-hot-toast';
import { Button as ButtonUI, IconWarningFilled } from 'takeat-design-system-ui-kit';
import api2 from '../../services/api2';
import { AlertContainer } from './styles';

export default function LogisticsFailWarning({
  sessionId,
  basketId,
  logisticId,
  logisticChannel,
  isWithdrawal,
  onRetrySuccess,
}) {
  const [loading, setLoading] = useState(false);

  const getLogisticDisplayName = (channel) => {
    const names = {
      'AGILIZONE': 'Agilizone',
      'PICKNGO': 'PickNGo',
      'FOODY': 'Foody Delivery'
    };
    return names[channel] || channel;
  };

  const handleRetry = useCallback(async () => {
    setLoading(true);
    try {
      let endpoint, newLogisticId;
      
      if (logisticChannel === 'AGILIZONE') {
        endpoint = `/restaurants/agilizone/resend/${sessionId}`;
        const response = await api2.post(endpoint);
        newLogisticId = response.data.agilizone_id;
      } else if (logisticChannel === 'FOODY') {
        endpoint = '/restaurants/foody-delivery/store';
        const response = await api2.post(endpoint, { session_id: sessionId });
        newLogisticId = response.data.foody_delivery_session_id;
      } else {
        endpoint = `/restaurants/opendelivery/send-logistic-order/${sessionId}`;
        const response = await api2.post(endpoint);
        newLogisticId = response.data.deliveryId;
      }
      
      if (onRetrySuccess) {
        onRetrySuccess(basketId, newLogisticId);
      }
      toast.success("Logística reenviada com sucesso!");
    } catch (error) {
      const displayName = getLogisticDisplayName(logisticChannel);
      toast.error(`Erro ao reenviar pedido para ${displayName}`);
      console.error(`Erro ao reenviar pedido para ${displayName}`, error);
    } finally {
      setLoading(false);
    }
  }, [sessionId, basketId, logisticChannel, onRetrySuccess]);

  if (logisticId || isWithdrawal) {
    return null;
  }

  return (
    <AlertContainer>
      <div className="alert-header">
        
        <div className="icon-container">
          <div className="icon-ring-outer">
            <div className="icon-ring-inner">
              <IconWarningFilled fontSize={20} fill="#c8131b"/>
            </div>
          </div>
        </div>

        <div className="alert-content">
          <h2 className="alert-title">Falha na criação do pedido</h2>
          <p className="alert-message">
            Não foi possível enviar o pedido para a <strong>{getLogisticDisplayName(logisticChannel) || 'logística'}</strong> devido a uma falha de comunicação.
          </p>
        </div>

      </div>

      <div className="alert-actions">
        <ButtonUI 
          style={{height:'40px', width: '100%', padding: '10px', fontSize: '16px'}}
          onClick={handleRetry} 
          loading={loading}
          disabled={loading}
          icon={<FaArrowRotateRight size={20}/> }
        >
          Tentar novamente
        </ButtonUI>
      </div>
    </AlertContainer>
  );
}